module.exports = __webpack_public_path__ + "img/55_35.9e3f59e8.png";